import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from "@mui/material";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

export default function EditStoreDialog({ open, onClose, store, onSave, onDelete }) {
  const [address, setAddress] = useState(store?.address || "");

  useEffect(() => {
    setAddress(store?.address || "");
  }, [store]);

  const handleSave = () => {
    onSave({ ...store, address });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit store</DialogTitle>
      <DialogContent>
        <Box mt={1}>
          <SoftInput
            fullWidth
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            margin="normal"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <SoftButton color="error" onClick={() => onDelete(store.id)}>
          Delete
        </SoftButton>
        <SoftButton onClick={onClose}>Cancel</SoftButton>
        <SoftButton variant="contained" color="success" onClick={handleSave}>
          Save
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}

EditStoreDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  store: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    address: PropTypes.string,
  }),
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

EditStoreDialog.defaultProps = {
  store: null,
};
